import React, { FunctionComponent } from "react";
import { ICalculatorTabInformationV2 } from "../../types/ICalculatorTabInformation";
import { IContentfulRichText } from "../../types/IContentfulRichText";
import "./styles.scss";
import { CalculatorResultsV2 } from "../../components/CalculatorResultsV2";

export interface ICalculatorTemplateV2 {
  title?: string;
  description?: IContentfulRichText | string;
  tabInformation: ICalculatorTabInformationV2[];
  id: string;
}

export const CalculatorTemplateV2: FunctionComponent<ICalculatorTemplateV2> = (props) => {
  const {
    title,
    tabInformation,
    id,
  } = props;

  return (
    <section className="calculatorTemplate" id={id}>
      <div className="calculatorTemplate-content">
        {title && <p>{title}</p>}
        {tabInformation[0].form}
        <div className="calculatorTemplate-results">
          <CalculatorResultsV2
            {...tabInformation[0].calculatorResults}
          />
        </div>
      </div>
    </section>
  );
};
